import { Injectable } from '@angular/core';
import { FirebaseService } from '../firebase.service';


@Injectable({
  providedIn: 'root'
})
export class SimuladoService {

  public materias = [];
  public quantidade ;
  
  private path: string = 'materias';
  

  constructor(public firebaseService: FirebaseService) {
  }
  //gera chave de pesquisa aleatoria
  getRandomIntInclusive() {
    let min = Math.ceil(0);
    let max = Math.floor(1000000);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  getRandomIntInclusiveMax(res) {
    let min = Math.ceil(0);
    let max = Math.floor(res);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  shuffle(array) {
    var currentIndex = array.length, temporaryValue, randomIndex;
  
    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
  
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
  
      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }
  
    return array;
  }

  getLastItemCollection(colecao, id, campo, limit){
    
    return this.firebaseService.getCollectionOrdenerDescLimit(this.path, id, colecao,  campo, limit);
  }

  getItemCollectionSearchLimit(colecao, id, campo, maximo ,limit){    
    return this.firebaseService.getItemCollectionWhereLimit(this.path, id, colecao, ref => ref.where(campo, '<=', maximo).orderBy(campo, "desc").limit(limit) );
  }

}
